import { compose, withState } from 'recompose';

const FaqHandlers = compose(
  withState('expanded', 'setExpanded', false),
);

export default FaqHandlers;
